import React from 'react';
import DialogContent from '../../../common/components/dialog-content/index.tsx';
import { LINK_TYPE } from '../../../common/const.tsx';
import getMessages from '../../../common/messages/index.tsx';

const messages = getMessages(LINK_TYPE);

type Props = {
	onDataChange: (arg1: { url: string; name: string; hasError?: boolean }) => void;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => (
	<DialogContent
		invalidUrlError={messages.invalidUrlError}
		urlCaption={messages.urlCaption}
		urlPlaceholder={messages.urlPlaceholder}
		nameCaption={messages.nameCaption}
		namePlaceholder={messages.namePlaceholder}
		urlAndNameLocked
		onChange={props.onDataChange}
	/>
);
